import React, { Component } from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { getBillingDiviDropDownIntegrated, getPracticeTypesIntegrated, getActiveAllocatedRegionsIntegrated } from '../../integration/MasterDataService';
import { getProjectResources } from '../../resourceManagement/ResourceService';
import { getTimesheetComplianceData } from './TimesheetReportService';
import Loader from '../../integration/components/Loader';
import { LOG_TYPES } from "../../integration/IntegrationEnums";
import * as loggerService from "../../integration/LoggerService";
import { saveAuditTrail } from '../../integration/auditTrail/AuditTrailService';
import moment from 'moment-timezone';

class TimesheetCompliance extends Component {
    _export;

    isMount = false;

    constructor(props) {
        super(props);

        this.state = {

            timesheetComplianceData: [],
            resources: [],
            resourcesAll: [],
            selectedResource: [],
            department: [],
            departmentAll: [],
            selectedDepartment: [],
            practice: [],
            practiceAll: [],
            selectedPractice: [],
            allocatedRegions: [],
            allocatedRegionsAll: [],
            selectedAllocatedRegion: [],
            fortyHoursFlag: false,
            firstDayOfWeek: null,
            lastDayOfWeek: null,
            newDate: new Date(),
            showSuccessImage: false,
            showErrorImage: false,
            skip: 0,
            take: 20,
            sort: [
                { field: 'ResourceName', dir: 'asc' }
            ],
            loading: false
        };
    }

    componentDidMount() {
        this.isMount = true;
        this.props.onHeaderTitleChange('Timesheet Compliance');
        this.setInitialData();
    }

    setInitialData = async() => {
        await this.setState({
            loading: true
        });
        await this.getAllActiveResources();
        await this.populateDepartments();
        await this.populatePractices();
        await this.getAllocatedRegions();
        await this.onSaveAuditTrail();
        this.setWeekDates(new Date(), true);
        await this.setState({
            loading: false
        });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    onSaveAuditTrail = () => {
        const auditTrail = {
            Action: 'Timesheet Compliance report viewed',
            RefType: 'Timesheet Compliance',
            RefId: window.LOGGED_USER.user,
            RefName: window.LOGGED_USER.displayName
        }
        saveAuditTrail(auditTrail)
    }

    getAllActiveResources = async () => {
        await getProjectResources().then(async res => {
            await this.setState({
                resources: res.data,
                resourcesAll: res.data,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populateDepartments = async () => {
        await getBillingDiviDropDownIntegrated().then(response => {
            const divisions = response.data.filter(el => el.IsActive === true && el.SFCode !== null)
            this.setState({
                department: divisions,
                departmentAll: divisions,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    }

    populatePractices = async () => {
        await getPracticeTypesIntegrated().then(response => {
            this.setState({
                practice: response.data,
                practiceAll: response.data
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    }

    getAllocatedRegions = async () => {
        await getActiveAllocatedRegionsIntegrated()
            .then(res => {
                this.setState({
                    allocatedRegions: res.data,
                    allocatedRegionsAll: res.data 
                })
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    filterData(filter, allData) {
        const data = allData.slice();
        return filterBy(data, filter);
    }

    filterResources = event => {
        if (this.isMount) {
        this.setState({
            resources: this.filterData(event.filter, this.state.resourcesAll)
        });
        }
    };

    filterChangeDepartment = event => {
        if (this.isMount) {
            this.setState({
                department: this.filterData(event.filter, this.state.departmentAll)
            });
        }
    };

    filterChangePractice = event => {
        if (this.isMount) {
            this.setState({
                practice: this.filterData(event.filter, this.state.practiceAll)
            });
        }
    };

    filterChangeAllocatedRegion = event => {
        if (this.isMount) {
            this.setState({
                allocatedRegions: this.filterData(event.filter, this.state.allocatedRegionsAll)
            });
        }
    };

    handleInputChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    handleCheckedInput = event => {
        const field = event.target.name;
        const value = event.target.checked;

        this.setState({
            [field]: value
        });
    };

    pageChange = event => {
        if (this.isMount) {
            this.setState({
                skip: event.page.skip,
                take: event.page.take
            });
        }
    };

    submitSearch = async(event) => {
        if (event) {
            event.preventDefault();
        } 

        if (this.isMount) {
            await this.setState({
                loading: true,
                skip: 0,
            });
        }
        const fields = {
            Resource: this.state.selectedResource,
            Department: this.state.selectedDepartment,
            Practice: this.state.selectedPractice,
            AllocatedRegion: this.state.selectedAllocatedRegion,
            firstDayOfWeek: moment(new Date(this.state.firstDayOfWeek)).format('YYYY-MM-DD'),
            lastDayOfWeek: moment(new Date(this.state.lastDayOfWeek)).format('YYYY-MM-DD'),
            fortyHoursFlag: this.state.fortyHoursFlag
        };

        if (fields.firstDayOfWeek && fields.lastDayOfWeek) {
            await getTimesheetComplianceData(fields)
            .then(res => {
                if (this.isMount) {
                    this.setState({
                        timesheetComplianceData: res.data,
                        loading: false,
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
        }   
        await this.setState({
            loading: false,
        });
    }

    cancelSearch = event => {
        event.preventDefault();
        if (this.isMount) {
            this.setState({
                selectedDepartment: [],
                selectedPractice: [],
                selectedAllocatedRegion: [],
                selectedResource: [],
                fortyHoursFlag: false
            });
        }    
    };

    exportExcel = () => {
        const auditTrail = {
            Action: 'Timesheet Compliance data exported to excel',
            RefType: 'Timesheet Compliance',
            RefId: window.LOGGED_USER.user,
            RefName: window.LOGGED_USER.displayName
        };
        saveAuditTrail(auditTrail);
        let excelDataSet = this.state.timesheetComplianceData;
        this._export.save(excelDataSet);
    };

    prevWeek = () => {
        const date = this.state.newDate;
        const newDate = new Date();
        const prevWeek = new Date(
            newDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate() - 7)
        );
        this.setState(
        {
            newDate: prevWeek,
            resourceList: []
        },
        () => this.setWeekDates(prevWeek, false)
        );
    };

    nextWeek = () => {
        const date = this.state.newDate;
        const newDate = new Date();
        const nextWeek = new Date(
            newDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate() + 7)
        );
        this.setState({
            newDate: nextWeek,
            resourceList: []
        },
        () => this.setWeekDates(nextWeek, false)
        );
    };

    setWeekDates = async (date, initLoading) => {
        if (moment(date).day() !== 0) {
          const firstMonOfWeek = new Date();
          const lastDayOfWeek = new Date();
          this.setState(
            {
                newDate: new Date(date),
                firstDayOfWeek: new Date(
                firstMonOfWeek.setFullYear(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate() - date.getDay() + 1
                )
              ),
              lastDayOfWeek: new Date(
                lastDayOfWeek.setFullYear(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate() - date.getDay() + 7
                )
              ),
            },
            () => {
                if(!initLoading){
                    this.submitSearch();
                } 
            });
        } else {
          this.setState(
            {
                newDate: new Date(date),
                firstDayOfWeek: new Date(moment(date).subtract(6, 'days')),
                lastDayOfWeek: new Date(moment(date)),
            },
            () => {
                if(!initLoading){
                    this.submitSearch();
                } 
            });
        }
    };

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-8">
                        <div className="main-heading">Timesheet Compliance</div>
                    </div>
                </div>
                <form onSubmit={this.submitSearch}>
                
                    <div className="row">
                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Resource:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect  
                                        data={this.state.resources}
                                        name="selectedResource"
                                        textField="Name"
                                        placeholder={'Please Select'}
                                        onChange={this.handleInputChange}
                                        value={this.state.selectedResource}
                                        filterable={true}
                                        onFilterChange={this.filterResources}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Department:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        name="selectedDepartment"
                                        textField="Name"
                                        value={this.state.selectedDepartment}
                                        data={this.state.department}
                                        placeholder={'Please Select'}
                                        filterable={true}
                                        onFilterChange={this.filterChangeDepartment}
                                        onChange={this.handleInputChange}
                                    />   
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Practice:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        name="selectedPractice"
                                        textField="Name"
                                        value={this.state.selectedPractice}
                                        data={this.state.practice}
                                        placeholder={'Please Select'}
                                        filterable={true}
                                        onFilterChange={this.filterChangePractice}
                                        onChange={this.handleInputChange}
                                    />   
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Resource Assignment:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        data={this.state.allocatedRegions}
                                        textField="Name"
                                        value={this.state.selectedAllocatedRegion}
                                        onChange={this.handleInputChange}
                                        placeholder="Please Select"
                                        filterable={true}
                                        name="selectedAllocatedRegion"
                                        onFilterChange={this.filterChangeAllocatedRegion}
                                    />   
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label></label></div>
                            </div>
                            <div className="d-block">
                                <fieldset>
                                    <label className="k-form-field">
                                        <input
                                            type="checkbox"
                                            id="auth-1rps"
                                            name="fortyHoursFlag"
                                            className="k-checkbox"
                                            value={this.state.fortyHoursFlag}
                                            onChange={this.handleCheckedInput}
                                        />
                                        <label className="k-checkbox-label" htmlFor="auth-1rps">Submitted less than 40 hours</label>
                                    </label>
                                </fieldset>
                            </div>
                        </div>

                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12 btn-align-right">
                        <Button primary={true} type="submit" onClick={this.submitSearch}>
                            Search
                        </Button>
                        <Button type="button" onClick={this.cancelSearch}>
                            Clear
                        </Button>
                        </div>
                    </div>

                </form>

                <div className="main-seperator" />

                <div className="row mb-3">
                    <div class="col-md-4">
                        <div className="d-inline-block d-flex align-items-center">
                            <div className="d-inline-block mr-2">
                                <label>Date:</label>
                            </div>
                            <div className="d-inline-block mr-2">
                                <DatePicker
                                    defaultValue={new Date()}
                                    format="MM/dd/yyyy"
                                    value={this.state.newDate}
                                    onChange={event => this.setWeekDates(event.target.value, false)}
                                />
                            </div>

                            <div className="d-inline-block">
                                <a type="button" onClick={() => this.prevWeek()}>
                                <div class="rounded-link d-flex align-items-center justify-content-center mr-2">
                                    <span class="k-icon k-i-arrow-chevron-left" />
                                </div>
                                </a>

                                <a type="button" onClick={() => this.nextWeek()}>
                                <div class="rounded-link d-flex align-items-center justify-content-center mr-2">
                                    <span class="k-icon k-i-arrow-chevron-right" />
                                </div>
                                </a>
                            </div>

                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="btn-align-right">
                            <Button primary className="pull-left" onClick={this.exportExcel}>
                                {'Export to Excel'}
                            </Button>
                        </div>
                    </div> 
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <ExcelExport
                            ref={(exporter) => {
                            this._export = exporter;
                            }}
                            fileName={'Timesheet Compliance - ' + moment(new Date()).format('MM-DD-YYYY')}
                        >
                            <ExcelExportColumn field="ResourceName" title="Name" />
                            <ExcelExportColumn field="StartDate" title="Start Date" />
                            <ExcelExportColumn field="EndDate" title="End Date" />
                            <ExcelExportColumn field="TotalHoursEntered" title="Total Hours Entered" />
                            <ExcelExportColumn field="TotalHoursSubmitted" title="Total Hours Submitted" />
                            <ExcelExportColumn field="Department" title="Department" />
                            <ExcelExportColumn field="Practice" title="Practice" />
                            <ExcelExportColumn field="ResourceAssignment" title="Resource Assignment" />
                        </ExcelExport>
                        <Grid
                            data={orderBy(this.state.timesheetComplianceData, this.state.sort).slice(
                                this.state.skip,
                                this.state.take + this.state.skip
                            )}
                            skip={this.state.skip}
                            take={this.state.take}
                            total={this.state.timesheetComplianceData.length}
                            pageable={true}
                            onPageChange={this.pageChange}
                            resizable
                            sortable={true}
                            sort={this.state.sort}
                            onSortChange={(e) => {
                                this.setState({
                                    sort: e.sort
                                });
                            }}
                        >
                            <Column field="ResourceName" title="Resource Name"/>
                            <Column field="StartDate" title="Start Date"/>
                            <Column field="EndDate" title="End Date"/>
                            <Column field="TotalHoursEntered" title="Total Hours Entered" />
                            <Column field="TotalHoursSubmitted" title="Total Hours Submitted" />
                            <Column field="Department" title="Resource Department"/>
                            <Column field="Practice" title="Resource Practice"/>
                            <Column field="ResourceAssignment" title="Resource Assignment"/>
                        </Grid>
                    </div>
                </div>
                <Loader loading={this.state.loading} />
            </div>
        );
    }
}   

export default TimesheetCompliance;



